export enum EstatusPostulacionType {
    PEDIENTE = 'Pendiente',
    VISTO = 'Visto',
    CERRADA = 'Cerrada'
}
